<template>
  <v-row no-gutters class="justify-start align-start pb-4">
    <v-col cols="auto">
      <admin-input-row-wrapper ref="input" v-bind="{ ...$attrs, ...$props }" :dataType="dataType" v-on="$listeners">
      </admin-input-row-wrapper>
    </v-col>
    <v-col cols="auto">
      <v-row no-gutters class="justify-flex-start">
        <v-col cols="auto" class="text-body-2">
          {{ translatedText }}
        </v-col>
        <v-col cols="12">
          <italic-subheader :straight-text="additionalText"> </italic-subheader>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ItalicSubheader from '@/components/ItalicSubheader';
import AdminInputRowWrapper from '@/components/AdminInputRowWrapper';

export default {
  name: 'PasswordRequirmentInput',
  components: {
    ItalicSubheader,
    AdminInputRowWrapper,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    translationPath: {
      type: String,
      required: true,
    },
    additionalText: {
      type: String,
      default: null,
    },
    dataType: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translatedText() {
      return this.$i18n.t(this.translationPath);
    },
  },
  methods: {
    save() {
      this.$refs.input.save();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>
